export const hongbao = {
    hb: "Red envelope",
    dps: "Big Giveaway",
    xdhb: "Limited-time red packets, with millions in rewards waiting for you to grab",
    fxhb: "Share red packets to earn even more rewards",
    khb: "Open Red Envelope",
    kqz: "Opening...",
    ylq: "Claimed",
    hdwks: "Event not started",
    hdjxz: "Event in progress",
    hdyjs: "Event ended",
    hddjs: "Event countdown",
    hdsj: "Event time",
    zwhd: "No active events",
    hblsjlxq: "My Red Packet Reward History",
    jxz: "In Progress",
    ygq: "Expired",
    dks: "Upcoming",
    zwjl: "No rewards yet",
    wnmztj: "You do not meet the event requirements",
    wxts: "Friendly reminder",
    yhwcrz: "The user has completed KYC verification and mobile number binding",
    yhwcjy: "The user has completed one of the following: spot trading ≥100 USDT, contract trading (excl. leverage) ≥100 USDT, options trading ≥100 USDT, or GameFi trading ≥100 USDT",
    djzh: "Risk-controlled or withdrawal-restricted accounts cannot participate in the event.",
    hdhbjl: "Reward Received",
    sqbj: "Better Luck",
    dkapp: "Open the APP",
    smewm: "Scan the QR code",
    wchdtj: "Complete the event requirements to claim the red packet",
    fxhd: "Share the event to get more red packets",
    jdcz: "Simple steps, earn rewards",
    hdhb: "Event Red Packets",
    zdqj: "Specified Period",
    wcjye: "Complete {type} trading volume {text} ≥ {amount} USDT",
    yhwfhtj: "Within {time} before the red packet launch, the user had no eligible transactions",
    hbsxq: "Within {time}{day} before the red packet launch, the user {text}",
    bhgg: "Excluding leverage",
    h: ", or ",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/hongbao/en.js